(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[278],{

/***/ 56029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ slider_product; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@splidejs/react-splide/dist/js/react-splide.esm.js
var react_splide_esm = __webpack_require__(67677);
// EXTERNAL MODULE: ./node_modules/@splidejs/splide-extension-grid/dist/js/splide-extension-grid.esm.js
var splide_extension_grid_esm = __webpack_require__(51466);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(40865);
// EXTERNAL MODULE: ./components/icons/ArrowLeft.tsx
var ArrowLeft = __webpack_require__(5505);
// EXTERNAL MODULE: ./components/icons/ArrowRight.tsx
var ArrowRight = __webpack_require__(10997);
// EXTERNAL MODULE: ./components/molecules/icon-button/index.ts + 1 modules
var icon_button = __webpack_require__(2234);
// EXTERNAL MODULE: ./components/molecules/slider-product/SliderProduct.module.css
var SliderProduct_module = __webpack_require__(46583);
var SliderProduct_module_default = /*#__PURE__*/__webpack_require__.n(SliderProduct_module);
;// CONCATENATED MODULE: ./components/molecules/slider-product/SliderProduct.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          ",
        "\n          ",
        "\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            ",
        "\n            ",
        "\n          "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








// TODO: Reemplazar la implementación custom de las flechas con SplideTrack
// @see https://github.com/Splidejs/splide/discussions/769#discussioncomment-2639518
// TODO: Bug con loop y la extensión grid
/**
 * SliderProduct
 */ var SliderProduct = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _splideClassName = param.splideClassName, splideClassName = _splideClassName === void 0 ? "" : _splideClassName, _type = param.type, type = _type === void 0 ? "slide" : _type, _perPage = param.perPage, perPage = _perPage === void 0 ? 6 : _perPage, _height = param.height, height = _height === void 0 ? "h-[var(--card-size-h)]" : _height, _arrowPosition = param.arrowPosition, arrowPosition = _arrowPosition === void 0 ? "end" : _arrowPosition, _centerSlide = param.centerSlide, centerSlide = _centerSlide === void 0 ? false : _centerSlide, _outline = param.outline, outline = _outline === void 0 ? true : _outline, _breakpoints = param.breakpoints, breakpoints = _breakpoints === void 0 ? {
        1280: {
            perPage: 5
        },
        1024: {
            perPage: 4
        },
        768: {
            perPage: 3,
            padding: 40
        },
        640: {
            padding: 40,
            perPage: 2
        },
        360: {
            padding: 40,
            perPage: 1
        }
    } : _breakpoints, _gap = param.gap, gap = _gap === void 0 ? "1px" : _gap, _extensions = param.extensions, extensions = _extensions === void 0 ? [
        "none"
    ] : _extensions, _grid = param.grid, grid = _grid === void 0 ? {
        rows: 1,
        cols: 2,
        gap: {
            row: "1rem",
            col: "1.5rem"
        }
    } : _grid, children = param.children;
    var OUTLINE_PADDING = outline ? "1px" : "0";
    var DEFUALT_PADDING = "16px";
    var splideRef = /*#__PURE__*/ (0,react.createRef)();
    var prevSlide = function() {
        var ref, ref1;
        return (ref = splideRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.splide) === null || ref1 === void 0 ? void 0 : ref1.go("<");
    };
    var nextSlide = function() {
        var ref, ref1;
        return (ref = splideRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.splide) === null || ref1 === void 0 ? void 0 : ref1.go(">");
    };
    var ref = (0,react.useState)({
        disabledPrev: true,
        disabledNext: false
    }), beginningOrEnd = ref[0], setBeginningOrEnd = ref[1];
    var checkPaginationState = function(splide) {
        return setBeginningOrEnd({
            disabledPrev: splide.Components.Controller.getPrev() === -1,
            disabledNext: splide.Components.Controller.getNext() === -1
        });
    };
    var adjustPadding = function(splide, track, rootParent, start, last, padding) {
        if (padding) {
            if (start === splide.index) {
                track.style.paddingLeft = OUTLINE_PADDING;
                if (rootParent) rootParent.style.paddingLeft = DEFUALT_PADDING;
            } else {
                track.style.paddingLeft = "".concat(padding, "px");
                if (rootParent) rootParent.style.paddingLeft = "0";
            }
            if (last === splide.index) {
                track.style.paddingRight = OUTLINE_PADDING;
                if (rootParent) rootParent.style.paddingRight = DEFUALT_PADDING;
            } else {
                track.style.paddingRight = "".concat(padding, "px");
                if (rootParent) rootParent.style.paddingRight = "0";
            }
        } else {
            track.style.paddingLeft = OUTLINE_PADDING;
            track.style.paddingRight = OUTLINE_PADDING;
            if (rootParent) rootParent.style.paddingLeft = "0";
            if (rootParent) rootParent.style.paddingRight = "0";
        }
    };
    var adjustAllPaddings = function(splide) {
        var last = splide.Components.Controller.getEnd();
        var start = 0;
        var padding = splide.options.padding;
        var track = splide.Components.Elements.track;
        var root = splide.Components.Elements.root;
        var rootParent = root.parentElement;
        var breakpoints = splide.options.breakpoints;
        if (breakpoints) {
            Object.entries(breakpoints).forEach(function(param, index) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                var breakpointKey = Object.keys(breakpoints)[index - 1];
                if (window.screen.width <= parseInt(key) && breakpointKey && (index > 0 && window.screen.width > parseInt(breakpointKey) || index === 0)) {
                    adjustPadding(splide, track, rootParent, start, last, value.padding);
                }
            });
        }
        adjustPadding(splide, track, rootParent, start, last, padding);
    };
    /**
   * Render slides.
   *
   * @return Slide nodes.
   */ var renderSlides = function() {
        return children === null || children === void 0 ? void 0 : children.map(function(child, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_splide_esm/* SplideSlide */.j, {
                className: centerSlide ? (SliderProduct_module_default())["c-slider-product__slide-center"] : "",
                children: child
            }, index);
        });
    };
    var options = (0,_object_spread/* default */.Z)({
        type: type,
        perPage: perPage,
        breakpoints: breakpoints,
        perMove: 1,
        pagination: false,
        arrows: false,
        height: height,
        lazyLoad: true
    }, extensions.includes("grid") ? {
        grid: grid
    } : {
        gap: gap
    });
    /**
   * Render the component.
   *
   * @return A React node.
   */ return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, className && {
        className: className
    }), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_splide_esm/* Splide */.t, {
                options: options,
                ref: splideRef,
                className: (0,es/* oneLine */.f9)(_templateObject(), outline ? (SliderProduct_module_default())["c-slider-product__slides-outline"] : "", splideClassName),
                onMove: function(splide) {
                    return adjustAllPaddings(splide);
                },
                onMoved: function(splide) {
                    return checkPaginationState(splide);
                },
                onMounted: function(splide) {
                    checkPaginationState(splide);
                    adjustAllPaddings(splide);
                },
                onResized: function(splide) {
                    return checkPaginationState(splide);
                },
                Extensions: extensions.includes("grid") ? {
                    Grid: splide_extension_grid_esm/* Grid */.r
                } : {},
                children: renderSlides()
            }),
            (!beginningOrEnd.disabledPrev || !beginningOrEnd.disabledNext) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,es/* oneLine */.f9)(_templateObject1(), (SliderProduct_module_default())["c-slider-product__navigation"], (SliderProduct_module_default())["c-slider-product__navigation-".concat(arrowPosition)]),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_button/* default */.Z, {
                        style: "dashed-outline",
                        onClick: prevSlide,
                        size: "medium",
                        disabled: type !== "loop" && beginningOrEnd.disabledPrev,
                        "aria-label": "Slide Anterior",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeft/* ArrowLeft */.X, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_button/* default */.Z, {
                        style: "dashed-outline",
                        onClick: nextSlide,
                        size: "medium",
                        disabled: type !== "loop" && beginningOrEnd.disabledNext,
                        "aria-label": "Slide Siguiente",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight/* ArrowRight */.o, {})
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/molecules/slider-product/index.ts

/* harmony default export */ var slider_product = (SliderProduct);


/***/ }),

/***/ 48141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ CardProductWordpress; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/molecules/card-product/index.ts + 15 modules
var card_product = __webpack_require__(42654);
;// CONCATENATED MODULE: ./lib/graphql/transformers/card-product/box.ts
var boxTransformer = function(box) {
    return {
        size: box.size,
        type: box.type,
        amount: box.amount
    };
};

// EXTERNAL MODULE: ./lib/graphql/transformers/card-product/badge.ts
var badge = __webpack_require__(61819);
// EXTERNAL MODULE: ./lib/graphql/transformers/product/woosb.ts
var woosb = __webpack_require__(73704);
// EXTERNAL MODULE: ./lib/utils/price.ts
var price = __webpack_require__(86359);
// EXTERNAL MODULE: ./lib/utils/gtm/helpers.ts
var helpers = __webpack_require__(20457);
// EXTERNAL MODULE: ./lib/utils/gtm/normalizeItem.tsx
var normalizeItem = __webpack_require__(44538);
// EXTERNAL MODULE: ./lib/utils/product.ts
var utils_product = __webpack_require__(60597);
;// CONCATENATED MODULE: ./components/templates/card-product/CardProductWordpress.tsx








var discountFormatter = function(discount, variantDiscount) {
    var _Math;
    var ref, _amount, _percentage;
    var maxDiscount = (_Math = Math).max.apply(_Math, (0,_to_consumable_array/* default */.Z)((ref = variantDiscount === null || variantDiscount === void 0 ? void 0 : variantDiscount.map(function(i) {
        return i.value ? i.value : 0;
    })) !== null && ref !== void 0 ? ref : []).concat([
        discount.type === "amount" ? (_amount = discount.amount) !== null && _amount !== void 0 ? _amount : 0 : (_percentage = discount.percentage) !== null && _percentage !== void 0 ? _percentage : 0, 
    ]));
    if (discount.type === "percentage") return "Hasta -".concat(maxDiscount, "%");
    if (discount.type === "amount") return "Hasta -".concat((0,price/* toCurrency */.j3)(maxDiscount !== null && maxDiscount !== void 0 ? maxDiscount : 0));
};
/**
 * CardProductWordpress
 */ var CardProductWordpress = function(param) {
    var product = param.product, _type = param.type, type = _type === void 0 ? "COMPLETE" : _type, itemListId = param.itemListId, itemListName = param.itemListName, itemIndex = param.itemIndex, numColumns = param.numColumns;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16;
    var card = product === null || product === void 0 ? void 0 : (ref = product.caracteriSticasDelProducto) === null || ref === void 0 ? void 0 : ref.card;
    var onClick = function() {
        (0,helpers/* gtmPush */.De)({
            event: "select_item",
            ecommerce: {
                items: [
                    (0,normalizeItem/* normalizeItem */.V)(product, itemListId, itemListName, itemIndex)
                ]
            }
        });
    };
    var isFalseVariable = function(product) {
        var ref, ref1;
        return (0,utils_product/* isVariable */.cG)(product.type) && (product === null || product === void 0 ? void 0 : (ref = product.variations) === null || ref === void 0 ? void 0 : (ref1 = ref.edges) === null || ref1 === void 0 ? void 0 : ref1.length) === 1;
    };
    var productID = isFalseVariable(product) ? product.variations.edges[0].node.databaseId : product.databaseId;
    var isConfigurable = (0,utils_product/* isConfigurableBundle */.CA)(product.type, product.woosbOptionalProducts);
    var productType = isFalseVariable(product) ? "SIMPLE" : (0,utils_product/* isBundle */.w_)(product.type) && !(0,utils_product/* isBundleWithoutVariables */.YC)(product.type, {
        stock: product.stockStatus,
        woosbIds: product.woosbIds,
        bundledItems: product.bundledItems
    }) && !isConfigurable ? "VARIABLE" : product.type;
    product.isMirakl = (0,utils_product/* isMirakl */.XT)(product === null || product === void 0 ? void 0 : product.metaData);
    var sellerInfo = product.isMirakl ? product === null || product === void 0 ? void 0 : (ref1 = product.variations) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.edges) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.node) === null || ref4 === void 0 ? void 0 : ref4.sellerInfo : product === null || product === void 0 ? void 0 : product.sellerInfo;
    var hasBox = (card === null || card === void 0 ? void 0 : card.box) && (card === null || card === void 0 ? void 0 : (ref5 = card.box) === null || ref5 === void 0 ? void 0 : ref5.active);
    var imageSize = hasBox ? "small" : numColumns > 4 ? "medium" : "large";
    var discountBundle = (0,woosb/* woosbDiscountTransformer */.m)(product);
    var discount = isConfigurable ? discountFormatter(discountBundle, product.customQuantityDiscounts) : "-".concat((0,price/* getPercentageDiscount */.To)((0,price/* priceToNumber */.Sk)(product.regularPrice), (0,price/* priceToNumber */.Sk)(product.salePrice)), "%");
    var _isConnectif, ref17, ref18, ref19, ref20, ref21, ref22, ref23;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(card_product/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        type: productType,
        productID: productID,
        href: product.uri,
        stock: product.stockStatus
    }, hasBox ? {
        box: boxTransformer(card.box)
    } : {}), {
        onClick: onClick,
        isConnectif: (_isConnectif = product.isConnectif) !== null && _isConnectif !== void 0 ? _isConnectif : false,
        isConfigurable: isConfigurable,
        editable: type === "COMPLETE",
        hasFreeShipping: (0,utils_product/* hasFreeShipping */.Ey)(product === null || product === void 0 ? void 0 : (ref6 = product.shippingClasses) === null || ref6 === void 0 ? void 0 : ref6.edges, sellerInfo, product.price),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(card_product/* default.Image */.Z.Image, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                src: (ref18 = (ref17 = card === null || card === void 0 ? void 0 : (ref7 = card.image) === null || ref7 === void 0 ? void 0 : ref7.sourceUrl) !== null && ref17 !== void 0 ? ref17 : (ref8 = product.image) === null || ref8 === void 0 ? void 0 : ref8.sourceUrl) !== null && ref18 !== void 0 ? ref18 : "",
                alt: (ref22 = (ref21 = (ref20 = (ref19 = card === null || card === void 0 ? void 0 : (ref9 = card.image) === null || ref9 === void 0 ? void 0 : ref9.altText) !== null && ref19 !== void 0 ? ref19 : (ref10 = product.image) === null || ref10 === void 0 ? void 0 : ref10.altText) !== null && ref20 !== void 0 ? ref20 : card === null || card === void 0 ? void 0 : card.name) !== null && ref21 !== void 0 ? ref21 : product.name) !== null && ref22 !== void 0 ? ref22 : ""
            }, (card === null || card === void 0 ? void 0 : card.imageBackgroundColor) ? {
                backgroundColor: card.imageBackgroundColor
            } : {}), {
                size: imageSize
            })),
            product.primaryCategory && /*#__PURE__*/ (0,jsx_runtime.jsx)(card_product/* default.Category */.Z.Category, {
                href: product.primaryCategory.path,
                children: product.primaryCategory.name
            }),
            (card === null || card === void 0 ? void 0 : (ref11 = card.badge) === null || ref11 === void 0 ? void 0 : ref11.active) && /*#__PURE__*/ (0,jsx_runtime.jsx)(card_product/* default.Badge */.Z.Badge, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,badge/* badgeTransformer */.k)(card === null || card === void 0 ? void 0 : card.badge, card === null || card === void 0 ? void 0 : card.lifeStyle)), {
                children: card === null || card === void 0 ? void 0 : (ref12 = card.badge) === null || ref12 === void 0 ? void 0 : ref12.text
            })),
            type === "COMPLETE" && product.onSale && /*#__PURE__*/ (0,jsx_runtime.jsx)(card_product/* default.Badge */.Z.Badge, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,badge/* badgeTransformer */.k)(undefined, card === null || card === void 0 ? void 0 : card.lifeStyle)), {
                children: discount
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(card_product/* default.Name */.Z.Name, {
                children: (ref23 = card === null || card === void 0 ? void 0 : card.name) !== null && ref23 !== void 0 ? ref23 : product.name
            }),
            sellerInfo && (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)(card_product/* default.Seller */.Z.Seller, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.slug) && {
                slug: sellerInfo.slug
            }), {
                children: sellerInfo.name
            })),
            type === "COMPLETE" && product.onSale && product.regularPrice && !isConfigurable && /*#__PURE__*/ (0,jsx_runtime.jsx)(card_product/* default.PriceRegular */.Z.PriceRegular, {
                children: (0,price/* toCurrency */.j3)((ref14 = (ref13 = product.regularPrice) === null || ref13 === void 0 ? void 0 : ref13.split("-")) === null || ref14 === void 0 ? void 0 : ref14[0])
            }),
            type === "COMPLETE" && product.price && !isConfigurable && /*#__PURE__*/ (0,jsx_runtime.jsx)(card_product/* default.PriceDiscounted */.Z.PriceDiscounted, {
                onSale: !!product.onSale,
                children: (0,price/* toCurrency */.j3)((ref16 = (ref15 = product.price) === null || ref15 === void 0 ? void 0 : ref15.split("-")) === null || ref16 === void 0 ? void 0 : ref16[0])
            })
        ]
    }));
};
CardProductWordpress.displayName = "CardProductWordpress";


/***/ }),

/***/ 80278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59203);
/* harmony import */ var _molecules__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(23034);
/* harmony import */ var _molecules__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35934);
/* harmony import */ var _molecules__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(56029);
/* harmony import */ var _molecules_grid_GridItem__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21971);
/* harmony import */ var _organisms__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14529);
/* harmony import */ var _templates__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(48141);
/* harmony import */ var _lib_graphql_transformers__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(81866);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82702);












var ProductosFlexible = function(param) {
    var bloque = param.bloque, id = param.id, productos = param.productos, className = param.className, itemIndex = param.itemIndex;
    var ref;
    var items = (0,_lib_utils__WEBPACK_IMPORTED_MODULE_2__/* .toArray */ .qo)(bloque.mostrarProductosRelacionados ? productos : bloque.productos).filter(Boolean).map(function(item) {
        var query = new URLSearchParams();
        if (bloque === null || bloque === void 0 ? void 0 : bloque.itemListId) query.set("itemListId", bloque.itemListId);
        if (bloque === null || bloque === void 0 ? void 0 : bloque.itemListName) query.set("itemListName", bloque.itemListName);
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, item), {
            uri: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(query).length > 0 ? "".concat(item.uri, "?").concat(query.toString()) : item.uri
        });
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        id: id,
        wrapper: true
    }, className && {
        className: className
    }), {
        as: "section"
    }), bloque.backgroundColorString ? {
        style: {
            backgroundColor: bloque.backgroundColorString
        },
        padding: "px-4 py-8 md:py-8"
    } : {}), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_organisms__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, bloque.titulo ? {
            title: bloque.titulo
        } : {}, ((ref = bloque.link) === null || ref === void 0 ? void 0 : ref.link) ? {
            link: {
                href: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_2__/* .removeBaseURL */ .t7)(bloque.link.link.url) || "/",
                label: bloque.link.label,
                size: bloque.link.size,
                style: bloque.link.style
            }
        } : {}, bloque.description ? {
            description: bloque.description
        } : {}, bloque.mostrarProductosRelacionados ? {
            title: "Productos Relacionados"
        } : {}), {
            productos: items,
            itemListId: bloque.itemListId,
            itemListName: bloque.itemListName,
            itemIndex: itemIndex,
            headingType: bloque.headingType,
            children: bloque.isGrid ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_molecules__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, Number(bloque.itemsPorPagina) === 4 && {
                lg: 4
            }), {
                children: items.map(function(item, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_molecules_grid_GridItem__WEBPACK_IMPORTED_MODULE_9__/* .GridItem */ .P, {
                        children: "cpt_banner" in item ? /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(_molecules__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, (0,_lib_graphql_transformers__WEBPACK_IMPORTED_MODULE_11__/* .cardBannerTransformer */ .$)(item.cpt_banner)), {
                            key: index
                        })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_templates__WEBPACK_IMPORTED_MODULE_12__/* .CardProductWordpress */ .S, {
                            product: item,
                            itemListName: bloque.itemListName,
                            itemListId: bloque.itemListId,
                            itemIndex: index,
                            numColumns: 4
                        }, index)
                    }, index);
                })
            })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_molecules__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                perPage: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_2__/* .isNumber */ .hj)(bloque.itemsPorPagina) ? Number(bloque.itemsPorPagina) : 6
            }, Number(bloque.itemsPorPagina) === 4 ? {
                breakpoints: {
                    1280: {
                        perPage: 4
                    },
                    1024: {
                        perPage: 3
                    },
                    768: {
                        padding: 40,
                        perPage: 2
                    },
                    640: {
                        padding: 40,
                        perPage: 2
                    },
                    450: {
                        padding: 40,
                        perPage: 1
                    }
                }
            } : {}), {
                className: "-mx-4 md:mx-0",
                children: items.map(function(item, index) {
                    return "cpt_banner" in item ? /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(_molecules__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, (0,_lib_graphql_transformers__WEBPACK_IMPORTED_MODULE_11__/* .cardBannerTransformer */ .$)(item.cpt_banner)), {
                        key: index
                    })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_templates__WEBPACK_IMPORTED_MODULE_12__/* .CardProductWordpress */ .S, {
                        product: item,
                        itemListName: bloque.itemListName,
                        itemListId: bloque.itemListId,
                        itemIndex: index,
                        numColumns: 4
                    }, index);
                })
            }))
        }))
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (ProductosFlexible);
ProductosFlexible.displayName = "FlexibleProductos";


/***/ }),

/***/ 46583:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"c-slider-product__slides-outline":"SliderProduct_c-slider-product__slides-outline__it71J","c-slider-product__slide-center":"SliderProduct_c-slider-product__slide-center__bLY0z","c-slider-product__navigation":"SliderProduct_c-slider-product__navigation__RAQUb","c-slider-product__navigation-end":"SliderProduct_c-slider-product__navigation-end__CM6eH","c-slider-product__navigation-center":"SliderProduct_c-slider-product__navigation-center__vBTXr"};

/***/ })

}]);